export const getBillVariable = (billData, billFrequency, billIndex, varName) => {
  let variable
  if (billFrequency === 'annually') {
    billFrequency = 'annual'
    variable = billData.bills_yearly[0][billFrequency][varName]
  } else {
    variable = billData.bills_yearly[0][billFrequency][billIndex][varName]
  }
  return variable || 0.0
}
export const getBillValue = (billData, billFrequency, billIndex, isIgnoreTax, isItalyProject = false) => {
  const electricityValue = getBillVariable(billData, billFrequency, billIndex, 'total_utility_bill_only')
  const gasValue = getBillVariable(billData, billFrequency, billIndex, 'total_gas_cost')
  const fuelValue = getBillVariable(billData, billFrequency, billIndex, 'total_fuel_cost')
  const tax = getBillVariable(billData, billFrequency, billIndex, 'tax')
  let billValue = electricityValue + gasValue + fuelValue
  if (isItalyProject) {
    const exportCredit = getBillVariable(billData, billFrequency, billIndex, 'feed_in_tariff')
    billValue = billValue - exportCredit // Subtract the export credit from the utility bill as we want to see them seperately in IT
  }
  const value = isIgnoreTax ? billValue : billValue + tax
  return value || 0.0
}
export const getTotalIncentive = (proposedBillData, billFrequency, billIndex, isIgnoreTax) => {
  const incentivesData = getBillVariable(proposedBillData, billFrequency, billIndex, 'incentives')
  if (isIgnoreTax) {
    return incentivesData.reduce((sum, incentive) => sum + incentive.ex_tax, 0)
  } else {
    return incentivesData.reduce((sum, incentive) => sum + incentive.inc_tax, 0)
  }
}
export const getBillSavings = (currentBillData, proposedBillData, billFrequency, billIndex, isIgnoreTax) => {
  const currentBill = getBillValue(currentBillData, billFrequency, billIndex, isIgnoreTax)
  const proposedBill = getBillValue(proposedBillData, billFrequency, billIndex, isIgnoreTax)
  const totalIncentive = getTotalIncentive(proposedBillData, billFrequency, billIndex, isIgnoreTax)
  const billSaving = currentBill - proposedBill + totalIncentive
  return billSaving || 0.0
}
